interface Category {
  label: string;
  url: string;
}

export const categories: Category[] = [
  { label: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html' },
  { label: 'Hoodies/Sweaters', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html' },
  { label: 'T-Shirts', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html' },
  { label: 'Jackets', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html' },
  { label: 'Pants/Shorts', url: 'https://kaspreadsheet.com/search-915/name/Shoes.html' },
  { label: 'Headwear', url: 'https://kaspreadsheet.com/search-916/name/Shoes.html' },
  { label: 'Sets', url: 'https://kaspreadsheet.com/search-917/name/Shoes.html' },
  { label: 'Underwear', url: 'https://kaspreadsheet.com/search-918/name/Shoes.html' },
  { label: 'Jersey', url: 'https://kaspreadsheet.com/search-919/name/Shoes.html' },
  { label: 'Accessories', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html' },
  { label: 'Bags', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html' },
  { label: 'Belts', url: 'https://kaspreadsheet.com/search-922/name/Shoes.html' },
  { label: 'Perfumes', url: 'https://kaspreadsheet.com/search-923/name/Shoes.html' },
  { label: 'Other Stuff', url: 'https://kaspreadsheet.com/search-924/name/Shoes.html' },
];

import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function CategoryDropdown() {
  const { t } = useTranslation('home');
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 px-4 py-2.5 bg-primary-500 text-background-50 rounded-xl text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
      >
        <i className="ri-list-check text-base"></i>
        <span>{t('nav_categories')}</span>
        <i className={`ri-arrow-down-s-line transition-transform ${isOpen ? 'rotate-180' : ''}`}></i>
      </button>

      {isOpen && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setIsOpen(false)} />
          <div className="absolute left-0 right-0 sm:left-auto sm:right-auto sm:w-64 mt-2 bg-background-50 border border-background-200 rounded-xl shadow-xl z-50 max-h-80 overflow-y-auto">
            <div className="p-2">
              {categories.map((cat) => (
                <a
                  key={cat.url}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="flex items-center gap-2 px-3 py-2.5 rounded-lg text-sm text-foreground-700 hover:bg-background-100 hover:text-primary-700 transition-colors"
                  onClick={() => setIsOpen(false)}
                >
                  <i className="ri-shopping-bag-3-line text-foreground-400"></i>
                  <span>{cat.label}</span>
                </a>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
}